import script from "./GeneralDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralDialog.vue?vue&type=script&setup=true&lang=js"

import "./GeneralDialog.vue?vue&type=style&index=0&id=089ac3d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-089ac3d8"]])

export default __exports__